<template>
  <div style="margin-bottom:15px;">
    <!-- <div class="title-section-content" style="padding:0px;">
      <h3>Curso</h3>
    </div>-->
    <banner :key="bannerKey" class="col-lg-12" style="margin-top:15px;" :course="course" :isEdit="true" />
    <div :class="{ 'has-error': $v.course.name.$error }" class="control-group col-lg-6">
      <label class="control-label" for="name">Nome *</label>

      <div class="controls">
        <input id="name" type="text" v-model="course.name" class="form-control" />
      </div>
    </div>

    <file-upload
      v-on:uploadComplete="updatePath"
      class="col-lg-6"
      :field="'Banner'"
      :filetype="'.jpg'"
    />

    <div :class="{ 'has-error': $v.course.description.$error }" class="control-group col-lg-12">
      <label class="control-label" for="description">Descrição *</label>

      <div class="controls">

        <textarea v-model="course.description" class="form-control" id="description" rows="8"></textarea>
        
      </div>
    </div>
  </div>
</template>


<style scoped>
.has-error {
  border-color: #a94442 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
}
</style>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import axios from "axios";
import FileUpload from "../../Utils/FileUpload";
import Banner from "../../Banner";

axios.defaults.withCredentials = true;

export default {
  props: ["course"],
  data() {
    return {
      selectedFile: null,
      bannerKey:0
    };
  },
  validations: {
    course: {
      name: { required },
      description: { required },
      image_path: { required }
    }
  },
  components: {
    "file-upload": FileUpload,
    banner: Banner
  },
  methods: {
    hasErrors() {
      this.$v.course.$touch();
      if (this.$v.course.$error) {
        return true;
      } else {
        return false;
      }
    },
    updatePath(value) {
      this.$emit("imageChanged", value);
      this.course.image_path = value;
      this.bannerKey+=1;
    }
  },
  created() {}
};
</script>
